import {sendEmail, sendSMS} from '@api/ticket'
import SelectSendMessage from '@/views/components/dialogs/select-send-message'
import OMath from '@/utils/math'
export default {
  components:{
    SelectSendMessage,
  },
  data(){
    return{
      auto_renew_close_data:'',
      email_auto_renew_close_data:'',
      share_auto_renew_close_data:'',
      init_share_content:'',
      init_email_content:'',
      init_refer_content:'',
      showAutoCloseSelectMessage:false,
      showAutoSelectMessage:false,
      renew_send_data:{}
    }
  },
  computed:{
    send_init_share_content(){
      let amount = ''
      let content = this.init_share_content
      let gross = ''
      this.quoteList.some(item => {
        let {extra_benefits_content} = item||{}
        if(item.quote_status == 1){
          amount = item.payable
          gross = item.gross
          if(extra_benefits_content){
            Object.keys(extra_benefits_content).forEach(key => {
              if(Number(extra_benefits_content[key].gross)>0)
                gross = Number(gross) + Number(extra_benefits_content[key].gross)
            })
          }
          return true
        }
      })
      if(typeof amount == 'number'){
        let money = OMath.formatMoney(amount,2,true)
        let gross_money = OMath.formatMoney(gross,2,true)
        content = content.replace('{{gross}}', gross_money)
        if(amount == gross){
          content = content.replace('after discount is {{amount}},', '')
          content = content.replace('，折扣後 {{amount}}', '')
          // if(this.isSME)
          content = content.replace('{{amount}}', money)
        }else{
          content = content.replace('{{amount}}', money)
        }
      }else{
        content = this.reject_content
      }
      return content
    },
    send_init_refer_content(){
      let amount = ''
      let content = this.init_refer_content
      let gross = ''
      this.quoteList.some(item => {
        let {extra_benefits_content} = item||{}
        if(item.quote_status == 1){
          amount = item.payable
          gross = item.gross
          if(extra_benefits_content){
            Object.keys(extra_benefits_content).forEach(key => {
              if(Number(extra_benefits_content[key].gross)>0)
                gross = Number(gross) + Number(extra_benefits_content[key].gross)
            })
          }
          return true
        }
      })
      if(typeof amount == 'number'){
        let money = OMath.formatMoney(amount,2,true)
        let gross_money = OMath.formatMoney(gross,2,true)
        content = content.replace('{{gross}}', gross_money)
        if(amount == gross){
          content = content.replace('after discount is {{amount}},', '')
          content = content.replace('，折扣後 {{amount}}', '')
          // if(this.isSME)
          content = content.replace('{{amount}}', money)
        }else{
          content = content.replace('{{amount}}', money)
        }
      }else{
        content = this.reject_content
      }
      return content
    },
    send_init_email_content(){
      let amount = ''
      let content = this.init_email_content
      let gross = ''
      this.quoteList.some(item => {
        let {extra_benefits_content} = item||{}
        if(item.quote_status == 1){
          amount = item.payable
          gross = item.gross
          if(extra_benefits_content){
            Object.keys(extra_benefits_content).forEach(key => {
              if(Number(extra_benefits_content[key].gross)>0)
                gross = Number(gross) + Number(extra_benefits_content[key].gross)
            })
          }
          return true
        }
      })
      if(typeof amount == 'number'){
        let money = OMath.formatMoney(amount,2,true)
        let gross_money = OMath.formatMoney(gross,2,true)
        content = content.replace('{{gross}}', gross_money)
        if(amount == gross){
          content = content.replace('after discount is {{amount}},', '')
          content = content.replace('，折扣後 {{amount}}', '')
          // if(this.isSME)
          content = content.replace('{{amount}}', money)
        }else{
          content = content.replace('{{amount}}', money)
        }
      }else{
        content = this.reject_content
      }
      return content
    },
    renew_reply(){
      let list = this.quoteList
      let flag = false
      list.some(item => {
        const { quote_status } = item
        if(quote_status == 1) {
          flag = true
        }
      })
      if(!flag){
        if(this.isFina)
          return this.initReferRejectContent
        return this.reject_content
      }
      return this.init_content
    },
    renew_email_reply(){
      let list = this.quoteList
      let flag = false
      list.some(item => {
        const { quote_status } = item
        if(quote_status == 1) {
          flag = true
        }
      })
      if(!flag){
        if(this.isFina)
          return this.initReferRejectContent
        return this.reject_content
      }
      return this.send_init_email_content
    },
    renew_share_reply(){
      let list = this.quoteList
      let flag = false
      list.some(item => {
        const { quote_status } = item
        if(quote_status == 1) {
          flag = true
        }
      })
      if(!flag){
        if(this.isFina)
          return this.initReferRejectContent
        return this.reject_content
      }
      return this.send_init_share_content
    },
    renew_refer_reply(){
      let list = this.quoteList
      let flag = false
      list.some(item => {
        const { quote_status } = item
        if(quote_status == 1) {
          flag = true
        }
      })
      if(!flag){
        if(this.isFina)
          return this.initReferRejectContent
        return this.reject_content
      }
      return this.send_init_refer_content
    },
  },
  methods:{
  }
}
